import(/* webpackMode: "eager" */ "/Users/gopal/BlindsCode/blindscommerce/app/faq/page.tsx");
